<template>
  <div>
    <div class="banner">
      <div class="banner-content">
        <img class="img-fluid" src="../assets/images/banner/activity_banner.jpg" alt="banner" />
        <div class="banner-text">
          <h1>活動專區</h1>
          <div class="banner-text-line"></div>
          <span>Activity Area</span>
        </div>
      </div>
    </div>
    <div class="contentContainer-noMove" :style="{ backgroundImage: 'url(' + BG + ')' }">
      <div class="content">
        <!-- 活動詳細頁面 -->
        <div v-if="step === 1">
          <div class="activityDetail-top">
            <div class="bread">
              <router-link to="/">
                <i class="fas fa-home fa-lg"></i>
              </router-link>
              <span>></span>
              活動專區
            </div>
          </div>
          <div class="activityDetail-title">
            <div class="activityDetail-title-date">
              <div class="day">
                {{ activityDetail.ActivityStartOn | moment("DD") }}
              </div>
              <div class="other">
                {{ month }}
                {{ activityDetail.ActivityStartOn | moment("YYYY") }}
              </div>
            </div>
            <div class="activityDetail-title-text">
              <!-- <div
                class="eventCard-detail-tag green"
                v-if="categoriesTitle && categoriesTitle === '學術研討會'"
              >
                學術研討會
              </div>
              <div
                class="eventCard-detail-tag orange"
                v-if="categoriesTitle && categoriesTitle === '會員大會'"
              >
                會員大會
              </div>
              <div
                class="eventCard-detail-tag skyBlue"
                v-if="categoriesTitle && categoriesTitle === '相關合辦活動'"
              >
                相關
                <br />合辦活動
              </div>
              <div
                class="eventCard-detail-tag red"
                v-if="
                  categoriesTitle && categoriesTitle === '口腔衛生人員繼續教育'
                "
              >
                口腔衛生人員繼續教育
              </div> -->
              <div
                class="eventCard-detail-tag"
                v-if="categoriesTitle"
                :style="{ background: categoryColors }"
              >
                {{ categoriesTitle }}
              </div>
              <h3>{{ activityDetail.Title }}</h3>
            </div>
            <div class="activityDetail-title-calendar">
              <a
                class="addCalendar"
                :href="`http://www.google.com/calendar/event?action=TEMPLATE&text=${activityDetail.Title}&dates=${startDay}/${endDay}&details=${activityDetail.Introduction}&location=&trp=false`"
                target="_blank"
                rel="noopener"
              >
                <img src="../assets/images/icon/addcalendar.png" alt="加入行事曆" />
                加入行事曆
              </a>
              <div
                class="btn blue-btn submission-btn"
                @click.prevent="nextStep"
                v-if="activityDetail.RequireSignUp && isTime"
              >
                <a class href="javascript:;"> 線上報名<br />(Registration) </a>
              </div>
            </div>
          </div>
          <div class="activityDetail-content">
            <div class="content-textBox">
              <div class="contribution-img">
                <!-- <img :src="activityDetail.Image" alt /> -->
                <img v-if="activityDetail.Picture" :src="activityDetail.Picture" alt />
                <img v-else src="../assets/images/continuing_pic.jpg" alt />
              </div>
              <div class="contribution-content">
                <div class="contribution-content-top">
                  <!-- 0514 暫時拿掉日期 -->
                  <!-- <div class="contribution-content-table">
                    <div class="contribution-content-info white-underLine">
                      <div>
                        <img src="../assets/images/icon/Calendar.png" alt />
                      </div>
                      活動日期
                    </div>
                    <div class="contribution-content-detail">
                      {{ activityDetail.StartOn | moment("YYYY-MM-DD") }} ~
                      {{ activityDetail.EndOn | moment("YYYY-MM-DD") }}
                    </div>
                  </div> -->
                  <div class="contribution-content-table" v-if="activityDetail.Location">
                    <div class="contribution-content-info white-underLine">
                      <div>
                        <img src="../assets/images/icon/pin_big.png" alt />
                      </div>
                      <span style="line-height: 1;"
                        >活動位置<br /><span style="font-size: 12px;">Location</span></span
                      >
                    </div>
                    <div class="contribution-content-detail">
                      {{ activityDetail.Location }}
                    </div>
                  </div>
                  <div class="contribution-content-table" v-if="activityDetail.Organizer">
                    <div class="contribution-content-info white-underLine">
                      <div>
                        <img src="../assets/images/icon/hand_big.png" alt />
                      </div>
                      <span style="line-height: 1;"
                        >主辦單位<br /><span style="font-size: 12px;">Organizer</span></span
                      >
                    </div>
                    <div class="contribution-content-detail">
                      {{ activityDetail.Organizer }}
                    </div>
                  </div>
                  <div class="contribution-content-table" v-if="activityDetail.CoOrganizer">
                    <div class="contribution-content-info white-underLine">
                      <div>
                        <img src="../assets/images/icon/hand_big.png" alt />
                      </div>
                      <span style="line-height: 1;"
                        >協辦單位<br /><span style="font-size: 12px;">Co-Organizer</span></span
                      >
                    </div>
                    <div class="contribution-content-detail">
                      {{ activityDetail.CoOrganizer }}
                    </div>
                  </div>
                  <div class="contribution-content-table">
                    <div class="contribution-content-info white-underLine">
                      <div>
                        <img src="../assets/images/icon/Calendar.png" alt />
                      </div>
                      <span style="line-height: 1;"
                        >報名時間<br /><span style="font-size: 12px;"
                          >Registration Period</span
                        ></span
                      >
                    </div>
                    <div class="contribution-content-detail">
                      {{ activityDetail.SignUpStartOn | moment("YYYY-MM-DD") }}
                      ~
                      {{ activityDetail.SignUpEndOn | moment("YYYY-MM-DD") }}
                    </div>
                  </div>
                  <div class="contribution-content-table">
                    <div class="contribution-content-info white-underLine">
                      <div>
                        <img src="../assets/images/icon/Calendar.png" alt />
                      </div>
                      <span style="line-height: 1;"
                        >活動時間<br /><span style="font-size: 12px;">Activity Period</span></span
                      >
                    </div>
                    <div class="contribution-content-detail">
                      {{ activityDetail.ActivityStartOn | moment("YYYY-MM-DD") }}
                      ~
                      {{ activityDetail.ActivityEndOn | moment("YYYY-MM-DD") }}
                    </div>
                  </div>
                  <div class="contribution-content-table" v-if="activityDetail.DocumentFile">
                    <div class="contribution-content-info white-underLine">
                      <div>
                        <img src="../assets/images/icon/download_03.png" alt />
                      </div>
                      <span style="line-height: 1;"
                        >下載檔案<br /><span style="font-size: 12px;">Downloads</span></span
                      >
                    </div>
                    <div class="contribution-content-detail">
                      <a href="#" @click.prevent="download(activityDetail.DocumentFile)">
                        <!-- <img src="../assets/images/icon/pdf.svg" alt="pdf" /> -->
                        {{ activityDetail.DocumentFile.split("/").pop().split(".")[0] }}
                      </a>
                    </div>
                  </div>
                  <!-- <div class="contribution-content-table mb-1">
                    <div class="contribution-content-info">
                      <div>
                        <img src="../assets/images/icon/pen_big.png" alt />
                      </div>
                      我要投稿
                    </div>
                    <div class="contribution-content-detail">
                      <div class="btn blue-btn submission-btn">
                        <a
                          href="javascript:;"
                          @click.prevent="getPlanID('9acaddasdhhyth')"
                          >前往投稿</a
                        >
                      </div>
                    </div>
                  </div> -->
                  <div
                    class="contribution-content-table price-table-rwd"
                    v-if="activityDetail.RequirePayment"
                  >
                    <div class="contribution-content-info">
                      <div class="price-icon">
                        <img src="../assets/images/icon/hands_big.png" alt />
                      </div>
                      <span style="line-height: 1;"
                        >報名費說明<br /><span style="font-size: 12px;"
                          >Registration Fee Description</span
                        ></span
                      >
                    </div>
                    <div class="price-table">
                      <div class="contribution-content-detail price white-leftLine">
                        <div class="contribution-content-info price identity">
                          <span style="line-height: 1;"
                            >身分<br /><span style="font-size: 12px;">Membership</span></span
                          >
                        </div>
                        <!-- <div
                          class="contribution-content-info price white-leftLine"
                          v-for="(fee, index) in feeItems"
                          :key="`feeTitle-${index}`"
                          :class="{ fast: index === 0, slow: index === 1 }"
                        >
                          <p>{{ $moment(fee.EndOn).format("YYYY.MM.DD") }}前</p>
                        </div> -->
                        <div class="contribution-content-info price white-leftLine">
                          <span style="line-height: 1;"
                            >費用<br /><span style="font-size: 12px;">Fee</span></span
                          >
                        </div>
                      </div>
                      <template v-if="allFee && allFee.length > 0">
                        <div
                          class="contribution-content-detail price price-detail"
                          v-for="(fee, index) in allFee"
                          :key="`fee-${index}`"
                        >
                          <div class="contribution-content-info price price-detail identity">
                            {{ fee.Title }}
                          </div>
                          <!-- <div
                          class="contribution-content-info price price-detail"
                          :class="{ fast: index === 0, slow: index === 1 }"
                        >
                          NTD {{ fee.Price }}
                        </div> -->
                          <div class="contribution-content-info price price-detail">
                            NTD {{ fee.Price }}
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="twoBtn-block">
                  <div
                    class="btn blue-btn submission-btn"
                    @click.prevent="nextStep"
                    v-if="activityDetail.RequireSignUp && isTime"
                  >
                    <a class href="javascript:;">
                      線上報名(Registration)
                      <img src="../assets/images/icon/plus_arrow.png" alt />
                    </a>
                  </div>
                </div>
                <div class="contribution-content-text">
                  <div v-html="activityDetail.Introduction"></div>
                  <div v-html="activityDetail.Description"></div>
                  <div v-html="activityDetail.Content"></div>
                  <!-- <div class="contact-info">
                    <div>聯絡資訊</div>
                    <ul class="list-unstyled">
                      <li>聯絡人：潘柔竹</li>
                      <li>電子信箱：oralhealth.taiwan@gmail.com</li>
                      <li>連絡電話：0965-106-869</li>
                    </ul>
                  </div> -->
                </div>
                <div class="twoBtn-block">
                  <div
                    class="btn blue-btn submission-btn"
                    @click.prevent="nextStep"
                    v-if="activityDetail.RequireSignUp && isTime"
                  >
                    <a class href="javascript:;">
                      線上報名(Registration)
                      <img src="../assets/images/icon/plus_arrow.png" alt />
                    </a>
                  </div>
                  <div class="contact-back">
                    <router-link to="/activity">
                      回列表頁(Return)
                      <img src="../assets/images/icon/back_icon.png" alt="回列表頁" />
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 活動報名頁面 -->
        <section class="detail" v-if="step == 2">
          <div class="content-title">
            <h2>活動基本資訊</h2>
            <div class="bread">
              <router-link to="/">
                <i class="fas fa-home fa-lg"></i>
              </router-link>
              <span>></span>
              活動專區
            </div>
          </div>
          <div class="box">
            <div class="act">
              <div class="info">
                <div class="img">
                  <img
                    v-if="activityDetail.Picture"
                    :src="activityDetail.Picture"
                    :alt="activityDetail.Title"
                  />
                  <img v-else src="../assets/images/continuing_pic.jpg" alt />
                </div>
                <div class="content">
                  <div class="eventCard-date">
                    <div class="eventCard-date-month">
                      <div class="day">
                        {{ activityDetail.StartOn | moment("DD") }}
                      </div>
                      <div class="month">{{ month }}</div>
                    </div>
                    <div class="eventCard-date-year">
                      {{ activityDetail.StartOn | moment("YYYY") }}
                    </div>
                    <div
                      class="eventCard-detail-tag"
                      v-if="categoriesTitle"
                      :style="{ background: categoryColors }"
                    >
                      {{ categoriesTitle }}
                    </div>
                  </div>
                  <div class="title">{{ activityDetail.Title }}</div>
                  <ul class="text list-unstyled">
                    <li>
                      <div class="li-title">
                        <div class="li-img">
                          <img src="../assets/images/icon/calendar_orange.png" alt="活動日期" />
                        </div>
                        活動日期:
                      </div>
                      <div class="li-content">
                        {{
                          $moment(activityDetail.ActivityStartOn)
                            .locale("zh-tw")
                            .format("YYYY.MM.DD")
                        }}
                      </div>
                    </li>
                    <li>
                      <div class="li-title">
                        <div class="li-img">
                          <img src="../assets/images/icon/pin_orange.png" alt="活動地點" />
                        </div>
                        活動地點:
                      </div>
                      <div class="li-content">
                        {{ activityDetail.Location }}
                      </div>
                    </li>
                    <li>
                      <div class="li-title">
                        <div class="li-img">
                          <img src="../assets/images/icon/hands_orange.png" alt="主辦單位" />
                        </div>
                        主辦單位:
                      </div>
                      <div class="li-content">
                        {{ activityDetail.Organizer ? activityDetail.Organizer : "無" }}
                      </div>
                    </li>
                    <li v-if="activityDetail.CoOrganizer">
                      <div class="li-title">
                        <div class="li-img">
                          <img src="../assets/images/icon/hands_orange.png" alt="協辦單位" />
                        </div>
                        協辦單位:
                      </div>
                      <div class="li-content">
                        {{ activityDetail.CoOrganizer ? activityDetail.CoOrganizer : "無" }}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="content-title">
              <h2>填寫報名人資訊</h2>
            </div>
            <div class="content-contact">
              <div class="member">
                <div class="input_span">
                  <span>姓名*<br />Name</span>
                  <input type="text" placeholder="輸入姓名" required v-model="JoinEvent.Name" />
                </div>
                <div class="input_span" v-if="inputControl.EngName">
                  <span>英文姓名<br />Eng Name</span>
                  <input type="text" placeholder="輸入姓名" required v-model="JoinEvent.EngName" />
                </div>
                <div class="input_span" v-if="inputControl.Country">
                  <span>國籍<br />Country</span>
                  <input type="text" placeholder="輸入國籍" required v-model="JoinEvent.Country" />
                </div>
                <div class="input_span">
                  <span>身分證字號*<br />ID</span>
                  <input
                    type="text"
                    placeholder="請輸入身分證字號"
                    required
                    v-model="JoinEvent.IDcard"
                  />
                </div>
                <div class="input_span">
                  <span>生日*<br />Birthday</span>
                  <input type="date" required v-model="JoinEvent.Birthday" />
                </div>
                <div class="input_span">
                  <span>聯絡電話*<br />Tel</span>
                  <input
                    type="text"
                    placeholder="請輸入連絡電話"
                    required
                    v-model="JoinEvent.Mobile"
                  />
                </div>
                <div class="input_span">
                  <span>電子信箱*<br />E-mail</span>
                  <input
                    type="email"
                    placeholder="請輸入電子郵件"
                    required
                    v-model="JoinEvent.Email"
                  />
                </div>
                <div class="input_span" v-if="inputControl.Affiliation">
                  <span>服務單位<br />Affiliated institution</span>
                  <input
                    type="text"
                    placeholder="請輸入服務單位"
                    required
                    v-model="JoinEvent.Affiliation"
                  />
                </div>
                <div class="input_span" v-if="inputControl.Education">
                  <span>就讀學校<br />School</span>
                  <input
                    type="text"
                    placeholder="請輸入就讀學校"
                    required
                    v-model="JoinEvent.Education"
                  />
                </div>
                <div class="input_span" v-if="inputControl.Position">
                  <span>職稱<br />Title</span>
                  <input
                    type="text"
                    placeholder="請輸入職稱"
                    required
                    v-model="JoinEvent.Position"
                  />
                </div>
                <div class="input_span" v-if="inputControl.Address">
                  <span>通訊地址<br />Address</span>
                  <input
                    type="input"
                    placeholder="請輸入通訊地址"
                    required
                    v-model="JoinEvent.Address"
                  />
                </div>
                <div class="input_span" v-if="inputControl.EducationScore">
                  <span>繼續教育積分<br />continued education</span>
                  <select class="w-40" v-model="JoinEvent.EducationScore">
                    <option value="無">無(None)</option>
                    <option value="醫師" v-if="activityDetail.Id !== 29">醫師(MD)</option>
                    <option value="牙醫師">牙醫師(Dentist)</option>
                    <option value="牙技師">牙技師(DT)</option>
                    <option value="護理師">護理師(RN)</option>
                    <option value="營養師" v-if="activityDetail.Id !== 29">營養師(Dietitian)</option>
                    <option value="語言治療師">語言治療師(ST)</option>
                    <option value="物理治療師" v-if="activityDetail.Id !== 29">物理治療師(PT)</option>
                    <option value="職能治療師" v-if="activityDetail.Id !== 29">職能治療師(OT)</option>
                    <option value="牙科助理">牙科助理</option>
                  </select>
                  <i style="color: red; max-width: 350px;">
                    若有需要積分者，請回復種類別。
                  </i>
                </div>
                <div class="input_span" v-if="inputControl.IsVegetarian">
                  <span>餐食<br />Meals</span>
                  <select v-model="JoinEvent.IsVegetarian">
                    <option value="false">葷(Carnivore)</option>
                    <option value="true">素(vegetarian)</option>
                  </select>
                </div>
                <div class="input_span" v-if="inputControl.IsAttendDinner">
                  <span>晚宴<br />Dinner</span>
                  <select v-model="JoinEvent.IsAttendDinner">
                    <option value="true">參加(Attend)</option>
                    <option value="false">不參加(Unable to Attend)</option>
                  </select>
                </div>
                <div class="input_span" v-if="inputControl.IsStay">
                  <span>是否住宿<br />Whether to stay</span>
                  <select v-model="JoinEvent.IsStay">
                    <option value="true">是(Yes)</option>
                    <option value="false">否(No)</option>
                  </select>
                </div>
                <div class="input_span" v-if="inputControl.StayDays">
                  <span>住宿天數<br />Number of days of stay</span>
                  <input
                    type="input"
                    placeholder="請輸入住宿天數"
                    required
                    v-model="JoinEvent.StayDays"
                  />
                </div>
                <div class="input_span" v-if="inputControl.StayPeople">
                  <span>住宿人數<br />Number of guests</span>
                  <input
                    type="input"
                    placeholder="請輸入住宿人數"
                    required
                    v-model="JoinEvent.StayPeople"
                  />
                </div>
              </div>
            </div>
            <div class="content-title" v-if="activityDetail.RequirePayment">
              <h2>費用<br />registery fee</h2>
            </div>
            <div class="cost-container">
              <div class="cost" v-if="activityDetail.RequirePayment">
                <div v-if="selectFee.Title" class="title">
                  {{ selectFee.Title }}
                </div>
                <ul class="signtpye">
                  <li>
                    <span>{{ selectFee.Title }}</span>
                    <span>NTD {{ selectFee.Price }}</span>
                  </li>
                </ul>
              </div>
              <div class="global_title nomb" v-if="activityDetail.RequirePayment"></div>
              <div class="total" v-if="activityDetail.RequirePayment">
                <span>小計</span>
                <span>NTD {{ selectFee.Price }}</span>
              </div>
            </div>
            <div class="btn-block activity">
              <div class="btn blue-btn submission-btn" @click.prevent="checkout">
                <a class href="javascript:;">
                  送出並繳費
                  <img src="../assets/images/icon/plus_arrow.png" alt />
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <Popup v-if="openPopup">
      <div class="popupPayType0" v-if="payType === '0' && activityDetail.RequirePayment">
        <div>
          <h3>
            恭喜您！已報名此次
            <br />
            {{ activityDetail.Title }}
          </h3>
          <p>
            請您於任何一部銀行或郵局的ATM自動提款機或網路ATM轉帳，輸入下方轉帳帳號及金額，並上傳匯款證明。
          </p>
          <h4>1.轉帳資料</h4>
          <div class="bank-account">
            <span>銀行代碼：013國泰世華銀行 <br />轉帳帳號：14703055054433903</span>
          </div>
          <p>
            ※提醒您，匯款完成後，
            <span>請將證明上傳並點擊完成，</span>
            <br />我們將盡快確認並發送活動報名通知信給您！
          </p>
          <h4>2.上傳繳費證明</h4>
          <div class="upload-block">
            <div class="input_span">
              <div class="fileArea">
                <label for="file" v-show="!fileName">上傳檔案</label>
                <input
                  id="file"
                  ref="file"
                  type="file"
                  name="File"
                  @change="toInputValue($event)"
                />
                <div v-show="!fileName">※檔案請小於2.0MB</div>
                <div class="file_name" v-show="fileName">
                  <input type="text" id="forFile" v-model="fileName" />
                  <div class="delete" @click="deleteFile">
                    <span>✖</span>
                    <span>刪除</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>
            欲查詢報名明細，請至
            <a href="#">活動繳費紀錄</a>
            <br />或是來電詢問相關人員，客服電話：02-22457896 <br />我們的服務時間為：週一至週五
            09:00-12:00;13:00-18:00
          </p>
        </div>
        <div class="btn blue-btn submission-btn" @click.prevent="closePopup">
          <a class href="javascript:;">確定</a>
        </div>
      </div>
      <div class="popupPayType1" v-if="payType === '1' && activityDetail.RequirePayment">
        <h3>
          恭喜您！已報名此次
          <br />
          {{ activityDetail.Title }}
        </h3>
        <p>
          請您於任何一部銀行或郵局的ATM自動提款機或網路ATM轉帳，輸入下方轉帳帳號及金額，當系統收到您的匯款時將發送活動報名通知信給您！
        </p>
        <h4>轉帳資料</h4>
        <div class="bank-account">
          <span>銀行代碼：013國泰世華銀行 <br />轉帳帳號：14703055054433903</span>
        </div>
        <p>※提醒您，匯款完成後，系統將發送活動報名通知信給您！</p>
        <p>
          欲查詢報名明細，請至
          <a href="#">活動繳費紀錄</a>
          <br />或是來電詢問相關人員，客服電話：02-22457896 <br />我們的服務時間為：週一至週五
          09:00-12:00;13:00-18:00
        </p>
        <div class="btn blue-btn submission-btn" @click.prevent="closePopup">
          <a class href="javascript:;">確定</a>
        </div>
      </div>
      <div class="popupPayTypeSuccess" v-if="payType === '2' && activityDetail.RequirePayment">
        <h3>
          恭喜您！已完成此次"活動報名"
          <br />
          您的報名成功通知信已經寄至
          <br />
          <br />
          <span class="orange">{{ JoinEvent.Email }}</span>
        </h3>
        <p>
          請至您的電子信箱收取信件，或您也可至"會員專區>活動紀錄(投稿)"確認此次報名資訊。
        </p>
        <p>
          如果經過一段時間，您仍然沒有收到報名成功通知信，郵件有可能被分類到垃圾信件，請查看您的垃圾信件。
        </p>
        <p>
          ※請設置<span class="orange">oralhealth.taiwan@gmail.com</span
          >郵件為非垃圾郵件，<br />並加入為聯絡人，避免郵件丟失。
        </p>
        <div class="btn blue-btn submission-btn" @click.prevent="closePopup">
          <a class href="javascript:;">確定</a>
        </div>
      </div>
    </Popup>
    <Popup v-if="MemberPopup">
      <div class="loginContent">
        <p>提醒您！</p>
        <p v-if="!activityDetail.RequireMember">
          若您是本會會員，請登入後進行報名，謝謝！
          <span style="display: block; font-size: 12px;"
            >如果您的會員資格已過期，請先繳納您的會費進行會員資格報名或登出後報名。</span
          >
        </p>
        <p v-else>本活動僅限會員報名，謝謝！</p>
      </div>
      <div class="twoBtn-block select-pop" v-if="!activityDetail.RequireMember">
        <div
          class="btn blue-btn"
          @click.prevent="openLoginbox"
          v-if="filterFeeItems && filterFeeItems.length > 0 && !token"
        >
          <a class href="javascript:;"> 會員登入<br />(member login) </a>
        </div>
        <div
          class="btn blue-btn blue-btn-outer long-btn"
          v-for="(item, index) in filterFeeItems"
          @click.prevent="nextStep(false, 'next', item)"
          :key="`select${index}`"
        >
          <a href="javascript:;"> {{ item.Title }} </a>
        </div>
      </div>
      <div class="twoBtn-block select-pop" v-else-if="activityDetail.RequireMember && !token">
        <div class="btn blue-btn" @click.prevent="openLoginbox">
          <a class href="javascript:;"> 會員登入<br />(member login) </a>
        </div>
      </div>
      <div class="twoBtn-block select-pop" v-else-if="activityDetail.RequireMember && token">
        <div
          class="btn blue-btn blue-btn-outer long-btn"
          v-for="(item, index) in filterFeeItems"
          @click.prevent="nextStep(false, 'next', item)"
          :key="`select${index}`"
        >
          <a href="javascript:;"> {{ item.Title }} </a>
        </div>
      </div>
      <div class="twoBtn-block" v-show="errMsg">
        <p>{{ errMsg }}</p>
      </div>
      <div>
        <div class="btn blue-btn blue-btn-outer long-btn" @click.prevent="MemberPopup = false">
          <a href="javascript:;"> 關閉<br />(Close) </a>
        </div>
      </div>
    </Popup>
    <Popup v-if="SuccessPopup">
      <div class="popupPayTypeSuccess">
        <h3>
          恭喜您！已完成此次"活動報名"
          <br />
          您的報名成功通知信已經寄至您的電子信箱
          <!-- <br />
          <span class="orange">{{ JoinEvent.Email }}</span> -->
          <br />
          您的報名代碼為：<span class="orange">{{ msg }}</span>
        </h3>
        <p>
          請至您的電子信箱收取信件，如您為會員也可至"會員專區>活動紀錄(投稿)"確認此次報名資訊。
        </p>
        <p>
          如果經過一段時間，您仍然沒有收到報名成功通知信，郵件有可能被分類到垃圾信件，請查看您的垃圾信件。
        </p>
        <p v-show="activityDetail.TopicList && activityDetail.TopicList.length > 0">
          <span style="font-weight: bolder;">如需投稿</span
          >，請至"會員專區>活動紀錄(投稿)"進行，或是網頁"底部活動/投稿查詢
          Inquiry"內輸入報名代碼進行
        </p>
        <p>
          <span style="font-weight: bolder;">活動當天報到使用之QR Coded</span
          >可於"會員專區>活動紀錄(投稿)"打開，或是網頁"底部活動/投稿查詢 Inquiry"內輸入報名代碼打開
        </p>
        <p>
          ※請設置<span class="orange">oralhealth.taiwan@gmail.com</span
          >郵件為非垃圾郵件，<br />並加入為聯絡人，避免郵件丟失。
        </p>
        <p>
          Congratulations!
          <br />
          You have completed this event registration, and your registration success notification
          letter has been sent to your mailbox.
          <!-- <br />
          <span class="orange">{{ JoinEvent.Email }}</span> -->
          <br />
          Your registration code :<span class="orange">{{ msg }}</span>
        </p>
        <p>
          If you still haven’t received the registration success notification letter after a period
          of time, it is possible that the email has been classified as junk mail. Please check your
          junk mail folder to ensure that the email hasn’t been misplaced
        </p>
        <p>
          Enter the website( https://www.tadhtw.org/inquire ) and key-in your registration code, you
          can:
        </p>
        <p>
          1.<span style="font-weight: bolder;">Abstract registration</span> to submit the
          abstract.<br />
          2.Receive <span style="font-weight: bolder;">QR code</span> for on-site check-in.
        </p>
        <div class="btn blue-btn submission-btn" @click.prevent="toIndex">
          <a class href="javascript:;">確定</a>
        </div>
      </div>
    </Popup>
    <form :action="PaymentUrl" id="submitForm" method="post">
      <input type="hidden" name="OrderId" v-model="payInfo.OrderId" />
      <input type="hidden" name="Token" v-model="payInfo.Token" />
      <input type="hidden" name="ReturnUrl" v-model="payInfo.ReturnUrl" />
      <input class="d-none" type="submit" value="送出表單" id="submitData" />
    </form>
  </div>
</template>

<script>
import $ from 'jquery';
import activityApi from '@/assets/api/activity';
import Popup from '@/components/Popup.vue';
import Common from '@/common';
import API from '@/assets/api/member';
import BG from '../assets/images/index_bg_big.png';

export default {
  name: 'activityDetail',
  components: {
    Popup,
  },
  data() {
    return {
      BG,
      calendarData: {
        title: '艾利根論文獎甄選活動!!',
        date: '20190711T000000+0800/20190817T000000+0800', // ('2019-08-17T00:00:00+08:00').replace(/-/g,'').replace(/:/g,'') 取正確時間
        details: 'test',
        location: 'test',
      },
      activityDetail: {},
      step: 1,
      Friends: [],
      JoinEvent: {
        Title: '',
        Name: '',
        EngName: '',
        Telephone: '',
        Mobile: '',
        Email: '',
        Affiliation: '',
        Position: '',
        ZipCode: '',
        Address: '',
        SelectedFee: {},
        IsVegetarian: false,
        IsAttendDinner: false,
        // MemberId: '',
        ActivityId: 0,
        Companions: [],
        Memo: '',
        IDcard: '',
        EducationScore: '無',
        Birthday: '',
        Country: '',
        IsStay: false,
        StayDays: '',
        StayPeople: '',
        Education: '',
      },
      payName: '',
      paySelf: 0,
      isLogin: false,
      payType: 'null',
      openPopup: false,
      fileName: '',
      MemberPopup: false,
      SuccessPopup: false,
      categrory: [],
      token: '',
      msg: '',
      payInfo: {
        OrderId: 0,
        Token: '',
        ReturnUrl: '',
      },
      PaymentUrl: '',
      startDay: '',
      endDay: '',
      SelectedFee: '',
      myFile: '',
      fullFileName: '',
      isTime: false,
      MemberInfo: {},
      StartDate: '',
      EndDate: '',
      isPayed: false,
      nowSelect: '',
      feeItems: [],
      filterFeeItems: [],
      allFee: [],
      selectFee: {},
      errMsg: '',
      inputControl: {
        EngName: false,
        Affiliation: false,
        Position: false,
        Education: false,
        Country: false,
        Address: false,
        EducationScore: false,
        IsVegetarian: false,
        IsAttendDinner: false,
        IsStay: false,
        StayDays: false,
        StayPeople: false,
      },
    };
  },
  methods: {
    getDetail(id) {
      const vm = this;
      activityApi.getActivityDetail(id).then((res) => {
        if (res.status === 200) {
          vm.activityDetail = res.data.Data;
          vm.startDay = vm.$moment(vm.activityDetail.ActivityStartOn).format('YYYYMMDD[T]HHmmss');
          vm.endDay = vm.$moment(vm.activityDetail.ActivityEndOn).format('YYYYMMDD[T]HHmmss');

          vm.isTimeTo();
        }
      });
    },
    getInput(id) {
      const vm = this;
      activityApi.getInput(id).then((res) => {
        if (res.status === 200) {
          vm.inputControl = res.data.Data;
        }
      });
    },
    async getFee(id) {
      const vm = this;
      await activityApi.getFee(id, vm.token).then((res) => {
        // console.log(res);
        if (res.status == 200) {
          vm.feeItems = res.data.Data.CurrentFeeItems;
          if (vm.token && vm.activityDetail.RequirePayment) {
            vm.filterFeeItems = vm.feeItems.filter(
              (item) => item.ApplyCategoryId == vm.MemberInfo.ApplyCategoryId,
            );
          } else {
            vm.filterFeeItems = vm.feeItems;
          }
        } else {
          vm.errMsg = res.data.Message;
        }
      });
      await activityApi.getAllFee(id, vm.token).then((res) => {
        if (res.status == 200) {
          vm.allFee = res.data.Data;
        }
      });
    },
    getPlanID(id) {
      const vm = this;
      vm.$store.commit('FROM', 'activity');
      vm.$router.push(`/plan/planId/${id}`);
    },
    addFriend() {
      const vm = this;
      const myFriends = vm.Friends;
      const arr = {
        Name: '',
        EngName: '',
        Title: 'null',
        IsVegetarian: false,
        IsAttendDinner: false,
      };
      myFriends.push(arr);
      // console.log(myFriends);
    },
    removeFriend(index) {
      const vm = this;
      const myFriends = vm.Friends;
      myFriends.splice(index, 1);
      vm.Friends = myFriends;
    },
    nextStep(member, type, data) {
      const vm = this;
      vm.SelectedFee = type;
      if (type === 'next' && vm.isLogin && vm.isPayed) {
        vm.step = 2;
        vm.selectFee = data;
        vm.MemberPopup = false;
        window.scrollTo(0, 300);
      } else if (type === 'next' && vm.isLogin && !vm.isPayed && vm.activityDetail.RequirePayment) {
        vm.$swal({
          icon: 'warning',
          text: '請先完成會費繳納再以會員身分報名',
          confirmButtonText: '確定',
        }).then(() => {
          vm.MemberPopup = false;
        });
      } else if (type === 'next') {
        vm.step = 2;
        vm.selectFee = data;
        vm.MemberPopup = false;
        window.scrollTo(0, 300);
      } else {
        vm.MemberPopup = true;
      }
    },
    checkout() {
      const vm = this;
      vm.$set(vm.JoinEvent, 'ActivityId', Number(vm.$route.params.activityId));
      if (
        vm.JoinEvent.Name === ''
        || vm.JoinEvent.Birthday === ''
        || vm.JoinEvent.Mobile === ''
        || vm.JoinEvent.Email === ''
        || vm.JoinEvent.IDcard === ''
      ) {
        vm.$swal({
          icon: 'warning',
          text: '尚有欄位未填寫，請檢查您的欄位!',
          confirmButtonText: '確定',
        });
        return false;
      }
      if (!Common.IsEmail(vm.JoinEvent.Email) && vm.activityDetail.Id !== 17) {
        vm.$swal({
          icon: 'warning',
          text: 'Email格式錯誤，請重新填寫!',
          confirmButtonText: '確定',
        });
        return false;
      }
      // console.log("隨同親友", vm.Friends);
      if (vm.Friends.length > 0) {
        const IsNull = vm.Friends.some(
          (item) => item.Name === '' || item.EngName === '' || item.Title === 'null',
        );
        if (IsNull) {
          vm.$swal({
            icon: 'warning',
            text: '隨行親友欄位，也都記得要填寫完畢哦!',
            confirmButtonText: '確定',
          });
          return false;
        }
        // console.log('test');
      }
      vm.$store.dispatch('updateLoading', true);
      const formData = new FormData();
      formData.append('Name', vm.JoinEvent.Name);
      formData.append('Mobile', vm.JoinEvent.Mobile);
      formData.append('Email', vm.JoinEvent.Email);
      formData.append('Position', vm.JoinEvent.Position);
      formData.append('Affiliation', vm.JoinEvent.Affiliation);
      formData.append('Address', vm.JoinEvent.Address);
      formData.append('Memo', vm.JoinEvent.Memo);
      formData.append('Title', vm.JoinEvent.Title);
      formData.append('SelectedFee', vm.selectFee);
      // if (vm.activityDetail.Id !== 15 && vm.activityDetail.Id !== 17 && vm.activityDetail.Id !== 18 && vm.activityDetail.Id !== 19 && vm.activityDetail.Id !== 20) {
      if (vm.fileName) {
        formData.append('Filename', `${vm.fileName}-${vm.JoinEvent.Name}`);
        formData.append('File', vm.myFile, vm.fullFileName);
      }
      vm.JoinEvent.SelectedFee = vm.selectFee;
      activityApi.postActivity(vm.token, vm.JoinEvent).then((res) => {
        vm.$store.dispatch('updateLoading', false);
        if (res.status === 200) {
          if (!vm.activityDetail.RequirePayment) {
            vm.msg = res.data.Message;
            vm.SuccessPopup = true;
          } else if (!res.data.Message) {
            vm.msg = res.data.Data.RegistrantNumber;
            Common.setCookie('msg', vm.msg, 0.35);
            vm.$store.dispatch('updateLoading', false);
            vm.payInfo.OrderId = res.data.Data.OrderId;
            vm.PaymentUrl = res.data.Data.PaymentUrl;
            vm.payInfo.Token = res.data.Data.Token;
            vm.payInfo.ReturnUrl = window.location.href;
            // console.log(vm.PaymentUrl);
            setTimeout(() => {
              document.getElementById('submitData').click();
            }, 1000);
            // location.href = res.Data;
          } else {
            vm.msg = res.data.Message;
            vm.SuccessPopup = true;
          }
        } else {
          const tmpText = res.data.Message;
          vm.$swal({
            icon: 'warning',
            text: tmpText,
            confirmButtonText: '確定',
          });
        }
        // console.log(res);
      });
    },
    closePopup() {
      const vm = this;
      if (vm.openPopup) {
        if (vm.payType === '0' && vm.fileName === '') {
          vm.$swal({
            icon: 'warning',
            text: '請上傳繳費證明！',
            confirmButtonText: '確定',
          });
          return false;
        }
        vm.fileName = '';
        vm.openPopup = false;
        vm.SuccessPopup = true;
      } else if (vm.SuccessPopup) {
        vm.SuccessPopup = false;
      }
    },
    toInputValue(e) {
      const vm = this;
      const File = e.target.files || e.dataTransfer.files;
      if (File[0].size > 6000000) {
        vm.$swal({
          icon: 'warning',
          text: '檔案大小超過 6MB，請重新選擇檔案',
          confirmButtonText: '確定',
        });
        return false;
      }
      // eslint-disable-next-line prefer-destructuring
      vm.myFile = File[0];
      const tmpFileName = File[0].name.split('.');
      if (tmpFileName.length >= 2) {
        // eslint-disable-next-line prefer-destructuring
        vm.fileName = tmpFileName[0];
      } else {
        vm.fileName = File[0].name;
      }
      vm.fullFileName = File[0].name;
      if (!/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(vm.fileName)) {
        vm.$swal({
          type: 'warning',
          text: '檔名請勿使用特殊符號或空格',
          confirmButtonText: '確定',
        }).then((data) => {
          if (data.value) {
            vm.deleteFile();
          }
        });
      }
    },
    toIndex() {
      const vm = this;
      vm.$router.push('/');
    },
    deleteFile() {
      const vm = this;
      vm.myFile = [];
      vm.fileName = '';
      vm.$refs.file.value = '';
    },
    openLoginbox() {
      const vm = this;
      // eslint-disable-next-line no-shadow
      const Loginbox = document.getElementById('loginbox');
      // console.log(Loginbox);
      vm.MemberPopup = false;
      const tops = $(document).scrollTop();
      $(document).bind('scroll', () => {
        $(document).scrollTop(tops);
      });
      Loginbox.style.display = 'flex';
    },
    // submit() {
    //   const vm = this;
    //   if (
    //     !vm.formData.Name
    //     || !vm.formData.Mobile
    //     || !vm.formData.Email
    //     || !vm.formData.Affiliation
    //     || !vm.formData.Position
    //     || !vm.myFile
    //     || !vm.fileName
    //   ) {
    //     vm.$swal({
    //       icon: 'warning',
    //       text: '尚有欄位未填寫',
    //       confirmButtonText: '確定',
    //     });
    //     return false;
    //   }
    //   const formData = new FormData();
    //   formData.append('Id', vm.guid);
    //   formData.append('Name', vm.formData.Name);
    //   formData.append('Mobile', vm.formData.Mobile);
    //   formData.append('Telephone', vm.formData.Mobile);
    //   formData.append('Email', vm.formData.Email);
    //   formData.append('Affiliation', vm.formData.Affiliation);
    //   formData.append('Position', vm.formData.Position);
    //   formData.append('File', vm.myFile, vm.fileName);
    //   // console.log(vm.myFile);
    //   // for (var pair of formData.entries()) {
    //   //   console.log(pair[0] + ", " + pair[1]);
    //   // }
    //   vm.isLoading = true;

    //   // eslint-disable-next-line no-undef
    //   // API.getSubmitSubmissions(vm.submissionId, formData).then((res) => {
    //   //   // console.log(res);
    //   //   setTimeout(() => {
    //   //     vm.isLoading = false;
    //   //   }, 500);
    //   //   if (res.Ok) {
    //   //     vm.$swal({
    //   //       icon: 'success',
    //   //       text: '投稿成功!',
    //   //       confirmButtonText: '確定',
    //   //     });
    //   //     vm.reset();
    //   //     const UrlString = window.location.href;
    //   //     const Url = new URL(UrlString);
    //   //     vm.submissionId = Url.searchParams.get('Id');
    //   //   } else {
    //   //     vm.$swal({
    //   //       icon: 'fail',
    //   //       text: '投稿失敗，請檢查您所填寫欄位及上傳的檔案，或著稍後在試!',
    //   //       confirmButtonText: '確定',
    //   //     });
    //   //   }
    //   // });
    //   vm.$swal({
    //     icon: 'success',
    //     text: '投稿成功!',
    //     confirmButtonText: '確定',
    //   }).then(() => { vm.reset(); });
    //   // vm.$refs.form.submit();
    // },
    getActivityCategory() {
      const vm = this;
      activityApi.getActivityCategory().then((res) => {
        if (res.status === 200) {
          vm.categrory = res.data.Data;
        }
      });
    },
    download(url) {
      const vm = this;
      const Type = url.split('/').pop().split('.').pop();
      // Common.download(url, { type: Type });
      const uA = window.navigator.userAgent;
      const isIE = /msie\s|trident\/|edge\//i.test(uA)
        && !!(
          'uniqueID' in document
          || 'documentMode' in document
          || 'ActiveXObject' in window
          || 'MSInputMethodContext' in window
        );
      let typeName;
      if (Type == 'pdf' || Type == 'PDF') {
        typeName = 'application/pdf';
      } else if (Type == 'doc') {
        typeName = 'application/msword';
      } else {
        typeName = `video/${Type}`;
      }
      vm.$http
        .get(url, { responseType: 'blob' })
        .then(({ data }) => {
          const blob = new Blob([data], { type: typeName });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `${url.split('/').pop().split('.')[0]}.${Type}`;

          if (isIE) {
            navigator.msSaveBlob(new Blob([data]), `${url.split('/').pop().split('.')[0]}.${Type}`);
          } else {
            link.click();
          }
        })
        .catch((err) => {
          console.log('錯誤', err);
        });
      return true;
    },
    isTimeTo() {
      const vm = this;
      if (
        vm.$moment().format('x') > vm.$moment(vm.activityDetail.SignUpStartOn).format('x')
        && vm.$moment().format('x') < vm.$moment(vm.activityDetail.SignUpEndOn).format('x')
      ) {
        vm.isTime = true;
      }
    },
  },
  created() {
    const vm = this;
    vm.getActivityCategory();
    vm.getDetail(vm.$route.params.activityId);
    vm.getInput(vm.$route.params.activityId);
    // console.log(vm.PriceType, vm.FeeItems);
    if (Common.getCookie('token')) {
      vm.isLogin = true;
      vm.token = Common.getCookie('token');
    }
    if (Common.GetUrlParams('status') === '200') {
      vm.msg = Common.getCookie('msg');
      activityApi.checkActivity(vm.msg).then(() => {});
      vm.SuccessPopup = true;
    }
    if (vm.isLogin) {
      API.Profile(vm.token).then((res) => {
        if (res.status === 200) {
          vm.MemberInfo = res.data.Data;
          vm.StartDate = res.data.Data.StartOn;
          vm.EndDate = res.data.Data.EndOn;
          if (new Date(vm.EndDate) > new Date()) {
            vm.isPayed = true;
          }
        }
      });
    }
    vm.getFee(vm.$route.params.activityId);
  },
  computed: {
    // EarlyDate() {
    //   const vm = this;
    //   return vm.$moment(vm.FeeItems[0].EndOn).format('YYYY-MM-DD');
    // },
    // JoinStartDate() {
    //   const vm = this;
    //   // console.log(vm.FeeItems);
    //   if (vm.activityDetail.RequirePayment) {
    //     // console.log(vm.FeeItems[0].StartOn);
    //     return vm.$moment(vm.FeeItems[0].StartOn).format('YYYY-MM-DD');
    //   }
    //   // console.log(vm.activityDetail.RegisterStartOn);
    //   return vm.$moment(vm.activityDetail.RegisterStartOn).format('YYYY-MM-DD');
    // },
    // JoinEndDate() {
    //   const vm = this;
    //   if (vm.activityDetail.RequirePayment) {
    //     const last = vm.FeeItems.length - 1;
    //     return vm.$moment(vm.FeeItems[last].EndOn).format('YYYY-MM-DD');
    //   }
    //   return vm.$moment(vm.activityDetail.RegisterEndOn).format('YYYY-MM-DD');
    // },
    // Friendprice() {
    //   const vm = this;
    //   return vm.FeeItems[vm.PriceType.Id].Companion;
    // },
    // 判斷有沒有早鳥
    // IsEarly() {
    //   const vm = this;
    //   const Early = vm.$moment(vm.feeItems[0].EndOn).valueOf();
    //   const Now = vm.$moment().valueOf();
    //   if (Early > Now) {
    //     return true;
    //   }
    //   return false;
    // },
    // PriceType() {
    //   const vm = this;
    //   const Now = vm.$moment().valueOf();
    //   const Type = '';
    //   const FeeSort = vm.feeItems.sort((a, b) => (vm.$moment(a.EndOn).valueOf() > vm.$moment(b.EndOn).valueOf() ? 1 : -1)).filter(
    //     (fee) => vm.$moment(fee.EndOn).valueOf() > vm.$moment().valueOf(),
    //   );
    //   return FeeSort[0];
    // },
    fromPath() {
      return this.$store.getters.from;
    },
    categoriesTitle() {
      const vm = this;
      let tmpTitle = '';
      if (vm.categrory && vm.categrory.length > 0) {
        vm.categrory.filter((item) => {
          if (
            vm.activityDetail.Categories
            && vm.activityDetail.Categories.length > 0
            && item.Id === vm.activityDetail.Categories[0]
          ) {
            tmpTitle = item.Title;
          }
        });
      }
      return tmpTitle;
    },
    categoryColors() {
      const vm = this;
      let tmpColor = '';
      if (vm.categrory && vm.categrory.length > 0) {
        vm.categrory.filter((item) => {
          if (
            vm.activityDetail.Categories
            && vm.activityDetail.Categories.length > 0
            && item.Id === vm.activityDetail.Categories[0]
          ) {
            tmpColor = item.CategoryColor;
          }
        });
      }
      return tmpColor;
    },
    month() {
      const vm = this;
      let tmpMonth;
      if (vm.activityDetail.ActivityStartOn) {
        tmpMonth = vm.activityDetail.ActivityStartOn.split('-');
        switch (tmpMonth[1]) {
          case '01':
            tmpMonth = 'JAN';
            break;
          case '02':
            tmpMonth = 'FEB';
            break;
          case '03':
            tmpMonth = 'MAR';
            break;
          case '04':
            tmpMonth = 'APR';
            break;
          case '05':
            tmpMonth = 'MAY';
            break;
          case '06':
            tmpMonth = 'JUN';
            break;
          case '07':
            tmpMonth = 'JUL';
            break;
          case '08':
            tmpMonth = 'AUG';
            break;
          case '09':
            tmpMonth = 'SEP';
            break;
          case '10':
            tmpMonth = 'OCT';
            break;
          case '11':
            tmpMonth = 'NOV';
            break;
          case '12':
            tmpMonth = 'DEC';
            break;

          default:
            break;
        }
      }

      return tmpMonth;
    },
  },
};
</script>

<style lang="scss" scoped>
.eventCard-date {
  display: flex;
  align-items: center;
  color: #001139;
  transition: all 0.5s;
  margin-right: 1.75rem;
  margin-bottom: 1.5rem;
}

.eventCard-date-month {
  line-height: 1;
  .day {
    font-size: 2.75rem;
    line-height: 1;
  }

  .month {
    font-size: 1.5rem;
  }
}

.eventCard-date-year {
  writing-mode: vertical-lr;
  font-size: 1.75rem;
  line-height: 1;
  margin-right: 1rem;

  // @media (max-width: 1024px) {
  //   margin-right: 1rem;
  // }
}
.eventCard-date {
}

.eventCard-date-year {
}

.eventCard-detail-tag {
  margin-bottom: 0;
}

.info {
  display: flex;
  padding: 1.5rem 0;

  @media (max-width: 1024px) {
    justify-content: center;
  }

  @media (max-width: 420px) {
    flex-direction: column;
    align-items: flex-start;
  }

  //   @media (max-width: 768px) {
  //   flex-direction: column;
  // }

  .img {
    @media (max-width: 1024px) {
      display: flex;
      align-items: center;
      width: 60%;
    }
    @media (max-width: 768px) {
      width: 50%;
    }

    @media (max-width: 420px) {
      width: 100%;
    }
    img {
      width: 100%;
    }
  }
  .content {
    padding: 1.5rem 2rem;
  }
}

.title {
  font-size: 1.5rem;
  color: #001139;
  margin-bottom: 1.5rem;
}

.text {
  margin-bottom: 0;
  li {
    display: flex;
    margin-bottom: 0.5rem;

    @media (max-width: 1024px) {
      flex-direction: column;
      margin-bottom: 1rem;
    }
    @media (max-width: 420px) {
      flex-direction: row;
    }
  }
}

.li-title {
  display: flex;
  color: #f68e56;
  margin-right: 0.8rem;
  min-width: 115px;
}

.li-img {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.8rem;
  img {
    max-width: 100%;
  }
}

.li-content {
  color: #676767;
}

.member {
  width: 100%;
}

.input_span {
  input {
    width: calc(100% - 190px);
    color: #001139;

    @media (max-width: 420px) {
      width: 100%;
    }

    &.w-40 {
      width: 40%;
      @media (max-width: 420px) {
        width: 100%;
      }
    }
  }

  select {
    width: 40%;
    padding: 2px 20px;
    @media (max-width: 420px) {
      width: 100%;
    }
  }
}

.content-title {
  &.activity {
    justify-content: flex-start;
    align-items: flex-end;

    h2 {
      margin-right: 10px;
    }

    span {
      margin-right: 5px;
      margin-bottom: 5px;
    }

    button {
      color: #fff;
      outline: none;
      border: unset;
      border-radius: 5px;
      background-color: #001139;
      margin-bottom: 5px;
    }
  }
}

.friend {
  padding: 30px 100px;
  @media (max-width: 1024px) {
    padding: 30px;
  }
  .item {
    padding: 30px 95px;
    border: 1px solid #959595;
    margin-bottom: 1.5rem;

    @media (max-width: 420px) {
      padding: 5px;
    }

    .title {
      display: flex;
      justify-content: space-between;
      span:last-child {
        cursor: pointer;
      }
    }
  }
}

.cost .signtpye {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-inline-start: 0;
}
.box .cost .signtpye li {
  padding: 8px 16px;
  display: flex;
  font-size: 1.3rem;
}
.box .cost .signtpye li > span:nth-child(1) {
  margin-right: 16px;
  color: #666;
}
.box .cost .signtpye li > span:nth-child(2),
.box .total > span:nth-child(2) {
  min-width: 110px;
  text-align: right;
}

.cost-container {
  padding: 30px 195px;
  @media (max-width: 1024px) {
    padding: 30px;
  }
  @media (max-width: 420px) {
    padding: 10px;
  }

  .title {
    text-align: right;
    padding: 10px 10px;

    &.isMember {
      background-color: #f68e56;
      color: #fff;
      font-size: 1.3rem;
    }
  }
  .input_span {
    // 讓下拉選單文字靠右
    select {
      width: 100%;
      text-align: right;
      text-align-last: right;
      color: #666;

      option {
        direction: rtl;
      }
    }
  }
}

.global_title {
  width: 100%;
  padding: 8px 16px;
  border-bottom: 1px solid #696969;
  font-size: 1.4rem;
  margin-bottom: 10px;
}

.detail .box .total {
  display: flex;
  justify-content: flex-end;
  padding: 8px 16px;
  color: #c0272d;
  font-size: 1.3rem;
}
.detail .box .total span:nth-child(1) {
  margin-right: 16px;
}

.btn-block {
  &.activity {
    text-align: center;
    padding-top: 2rem;
  }
}
.upload-block {
  .input_span {
    justify-content: center;
  }
}

.input_span {
  .fileArea {
    label {
      display: block;
      padding: 5px 24px;
      background-color: #f68e56;
      color: #fff;
      cursor: pointer;
    }
    input[type="file"] {
      padding: 2px 20px;
      width: 100%;
      display: none;
    }
  }
}

#popup .bg .content .delete span {
  padding: 0;
  width: unset;
  margin-right: 0;
  cursor: pointer;
}

.file_name {
  display: flex;
  align-items: center;
  flex: 1;
  input[type="text"] {
    width: 100%;
  }
}

.file_name .delete {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.file_name .delete span:nth-child(1) {
  color: #f00;
  font-weight: 600;
  padding: 0 10px;
  font-size: 1.5rem;
  width: unset;
  text-align: unset;
  margin-right: unset;
}
.file_name .delete span:nth-child(2) {
  font-weight: 600;
  display: flex;
  align-items: center;
  cursor: pointer;
  width: unset;
  text-align: unset;
  margin-right: unset;
}

.popupPayType0 {
  @media (max-width: 420px) {
    padding-top: 100px;
  }
  @media (max-width: 375px) {
    padding-top: 250px;
  }
  @media (max-width: 320px) {
    padding-top: 450px;
  }
}

.popupPayType1 {
  @media (max-width: 360px) {
    padding-top: 150px;
  }
  @media (max-width: 320px) {
    padding-top: 300px;
  }
}

.popupPayTypeSuccess {
  @media (max-width: 767px) {
    h3 {
      font-size: 1.25rem;
    }

    p {
      margin-bottom: 0;
    }
  }
  @media (max-width: 360px) {
    // padding-top: 100px;
  }
  @media (max-width: 320px) {
    // padding-top: 200px;
  }
}

.activityDetail-title-text {
  .eventCard-detail-tag {
    @media (max-width: 420px) {
      margin-right: 0;
      margin-bottom: 0.5rem;
    }
  }
}

.eventCard-date-month {
  line-height: 1;
  .day {
    font-size: 2.75rem;
    line-height: 1;
  }

  .month {
    font-size: 1.5rem;
  }
}

.twoBtn-block {
  flex-wrap: wrap;

  .blue-btn {
    margin-right: 10px;
    margin-bottom: 10px;
  }

  &.select-pop {
    align-items: stretch;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.contribution-content-text {
  word-break: break-all;
}

.activityDetail-title-calendar {
  .btn.blue-btn {
    display: none;
  }
  @media (max-width: 767px) {
    background-color: initial;
    display: flex;
    width: 100%;
    justify-content: space-around;

    .addCalendar {
      background-color: #5bb6e3;
      border-radius: 5px;
    }

    .btn.blue-btn {
      width: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;

      a {
        display: block;
      }
    }
  }
}
</style>
